import * as React from 'react'

const SvgSelect = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#select_svg__clip0)" fill="currentColor">
      <path d="M2.667 6.667a1.334 1.334 0 01-1.334-1.334V4c0-2.205 1.795-4 4-4h1.334a1.334 1.334 0 010 2.667H5.333C4.6 2.667 4 3.265 4 4v1.333c0 .736-.597 1.334-1.333 1.334zM26.667 6.667a1.334 1.334 0 01-1.334-1.334V4c0-.735-.598-1.333-1.333-1.333h-1.333a1.334 1.334 0 010-2.667H24c2.205 0 4 1.795 4 4v1.333c0 .736-.597 1.334-1.333 1.334zM17.333 2.667H12A1.334 1.334 0 0112 0h5.333a1.334 1.334 0 010 2.667zM14.667 26.667H12A1.334 1.334 0 0112 24h2.667a1.334 1.334 0 010 2.667zM6.667 26.667H5.333c-2.205 0-4-1.795-4-4v-1.334a1.334 1.334 0 012.667 0v1.334C4 23.4 4.599 24 5.333 24h1.334a1.334 1.334 0 010 2.667zM2.667 17.333A1.334 1.334 0 011.333 16v-5.333a1.334 1.334 0 012.667 0V16c0 .736-.597 1.333-1.333 1.333zM26.667 14.667a1.334 1.334 0 01-1.334-1.334v-2.666a1.334 1.334 0 012.667 0v2.666c0 .736-.597 1.334-1.333 1.334zM31.728 24.832L19.151 12.255a.87.87 0 00-1.484.615v18.26a.87.87 0 001.494.603l5.223-5.416h6.732a.87.87 0 00.612-1.485z" />
    </g>
    <defs>
      <clipPath id="select_svg__clip0">
        <path fill="currentColor" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgSelect
